import BaseDataTransformer from '../base-data-transformer/base-data-transformer';

class NamedChartDataToKeyFigureTransformer extends BaseDataTransformer {
  // eslint-disable-next-line no-unused-vars
  transform(data, options) {
    // Expected format for key figure visualizer:
    // [{name: string, value: number}]

    const keyfigures = {};

    if (!data.data) {
      return [];
    }

    data.data.forEach((row) => {
      const name = row.values[0];
      const value = row.values[1];

      let floatValue = value ? parseFloat(value.replace(',', '.')) : null;

      if (Number.isNaN(floatValue)) {
        floatValue = value;
      }

      if (keyfigures[name] && value) {
        if (floatValue || floatValue === 0) {
          keyfigures[name] += floatValue;
        } else {
          keyfigures[name] += value;
        }
      } else if (!keyfigures[name]) {
        if (floatValue === 0) {
          keyfigures[name] = 0;
        } else {
          keyfigures[name] = floatValue || value || 0;
        }
      }
    });

    return Object.keys(keyfigures).map(key => ({
      name: key,
      value: keyfigures[key],
      meta: data.meta,
    }));
  }
}

export default NamedChartDataToKeyFigureTransformer;
